export default __webpack_public_path__ + "static/media/congrats-logo.03e0039e.svg";